// Generated by CoffeeScript 2.7.0
var Actions;

export default Actions = Vue.extend({
  props: {
    initialActions: {
      type: Array,
      default: []
    }
  },
  data: function() {
    return {
      count: this.initialActions.length
    };
  },
  template: `<div class="action-chips">
  <div class="slp-tooltip" v-if="showToolTip" :data-title="toolTip"></div>
  <div class="chips">
    <span class="chip mr-1 text-ellipsis"
          v-for='action in actions'
          :key='action.id'
          ref="actionsChipRef">{{ action.name }}</span>
  </div>
  <span class="chip-placeholder mt-1" v-if="showEllipsis">...</span>
</div>`,
  computed: {
    showEllipsis: function() {
      return this.showToolTip && (this.initialActions.length > 1);
    },
    toolTip: function() {
      return _.map(this.initialActions, function(action) {
        return action.name;
      }).join('、');
    },
    showToolTip: function() {
      return this.count < this.initialActions.length || this.count === 1;
    },
    actions: function() {
      if (this.showToolTip) {
        return this.initialActions.slice(0, this.count);
      } else {
        return this.initialActions;
      }
    }
  },
  mounted: function() {
    var chipChildren;
    chipChildren = this.$refs.actionsChipRef;
    if (!chipChildren) {
      return;
    }
    return this._setChipCountFunc(chipChildren, this.$el.offsetWidth);
  },
  methods: {
    _setChipCountFunc: function(chipChildren, maxWidth) {
      var chipChild, i, len, num, width;
      num = 0;
      width = 0;
      for (i = 0, len = chipChildren.length; i < len; i++) {
        chipChild = chipChildren[i];
        // chip的margin-right是8px
        width += chipChild.offsetWidth + 8;
        if (width > maxWidth && num > 0) {
          break;
        }
        num++;
      }
      return this.count = num;
    }
  }
});
